module.exports = __webpack_public_path__ + "img/ring_y_c_0_0.bae886da.png";